import { Link, useLocation } from "react-router-dom";
import { MessageCircle, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { getBorradorToken } from "../utils/borrador";

export const BorradorBanner = () => {
  const { user } = useAuth();
  const location = useLocation();
  const token = getBorradorToken();

  if (!user || !token || location.pathname === "/add-spot") return null;

  return (
    <Link
      to={`/add-spot?borrador=${encodeURIComponent(token)}`}
      data-testid="borrador-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-2.5 rounded-full bg-violet-600 hover:bg-violet-500 text-white text-xs sm:text-sm font-medium shadow-lg shadow-violet-500/40 transition-all max-w-[92vw]"
    >
      <MessageCircle className="w-4 h-4 flex-shrink-0" />
      <span className="truncate">Tienes un anuncio preparado por WhatsApp. Terminar de publicarlo</span>
      <ArrowRight className="w-4 h-4 flex-shrink-0" />
    </Link>
  );
};
